// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__3dzvr","profileList":"Profile_profileList__3vTor","profileListItem":"Profile_profileListItem__2th0t","buttonBox":"Profile_buttonBox__1JlBI"};